var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex gap-4 flex-col" },
    [
      _c("due-diligence-title", { staticClass: "pb-2" }),
      _c(
        "p",
        {
          staticStyle: {
            "line-height": "130%",
            "margin-top": "0.49cm",
            "margin-bottom": "0.49cm"
          },
          attrs: { align: "justify" }
        },
        [
          _c("font", { attrs: { face: "Calibri, serif" } }),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_vm._v(" A ")]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v(_vm._s(_vm.legalEntity.company_name))])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    ", inscrita no CNPJ/MF sob o nº " +
                      _vm._s(_vm.legalEntity.cnpj_formmated) +
                      ", (“" +
                      _vm._s(_vm.legalEntity.trading_name) +
                      "”) tem a obrigação legal de garantir a segurança dos dados pessoais de seus colaboradores, clientes, parceiros e representantes legais, doravante denominados “titulares de dados pessoais”. "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: {
            "line-height": "130%",
            "margin-top": "0.49cm",
            "margin-bottom": "0.49cm",
            background: "#fefefe"
          },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    "Para estabelecer uma relação de confiança, transparência e boa-fé com nossos parceiros, elaboramos este documento. Seu principal objetivo é avaliar e categorizar o grau de conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD) dos terceiros com quem compartilhamos dados pessoais. Por meio deste formulário, buscamos compreender as práticas de coleta, uso, armazenamento, compartilhamento e exclusão de dados pessoais que são controlados por nós e eventualmente compartilhados com terceiros (Operadores). "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: {
            "line-height": "130%",
            "margin-top": "0.49cm",
            "margin-bottom": "0.49cm",
            background: "#fefefe"
          },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    "Os parceiros abrangidos por este documento se dividem em três categorias: "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ol", { attrs: { type: "a" } }, [
        _c("li", { attrs: { value: "a" } }, [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-top": "0.49cm",
                "margin-bottom": "0cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                { attrs: { face: "Calibri, serif" } },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "font-size": "13pt" },
                      attrs: { size: "3" }
                    },
                    [_c("b", [_vm._v("a. Prestadores de Serviço: ")])]
                  )
                ],
                1
              ),
              _c(
                "font",
                { attrs: { face: "Calibri, serif" } },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "font-size": "13pt" },
                      attrs: { size: "3" }
                    },
                    [
                      _vm._v(
                        " pessoas jurídicas de direito privado que nos prestam serviços; "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                { attrs: { face: "Calibri, serif" } },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "font-size": "13pt" },
                      attrs: { size: "3" }
                    },
                    [_c("b", [_vm._v("b. Fornecedores: ")])]
                  )
                ],
                1
              ),
              _c(
                "font",
                { attrs: { face: "Calibri, serif" } },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "font-size": "13pt" },
                      attrs: { size: "3" }
                    },
                    [
                      _vm._v(
                        " pessoas jurídicas de direito privado que nos fornecem tecnologia e suporte para nossas atividades empresariais; "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("c. Demais terceiros:")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " pessoas físicas ou jurídicas que mantêm uma relação jurídica conosco e nos auxiliam em nossas atividades empresariais. "
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "p",
        {
          staticStyle: { "line-height": "100%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            {
              staticStyle: { "font-size": "13pt" },
              attrs: { size: "3", face: "Calibri, serif" }
            },
            [_c("b", [_vm._v("ORIENTAÇÕES PARA O PREENCHIMENTO DO DOCUMENTO")])]
          )
        ],
        1
      ),
      _c("ol", [
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("1. Objetivo do documento: ")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " Este documento integra o Programa de Adequação à Lei Geral de Proteção de Dados Pessoais e à Segurança da Informação da organização. Seu propósito é estabelecer regras de boas práticas para o tratamento de dados pessoais, levando em conta a natureza, escopo, finalidade, riscos e benefícios do tratamento, conforme o art. 50 da LGPD. "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("2. Preenchimento dos itens: ")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " Para os itens que requerem avaliação de conformidade com a LGPD, o parceiro deve indicar o grau de cumprimento e, quando aplicável, fornecer justificativas detalhadas. Recomenda-se que as respostas sejam o mais completas e específicas possível, com informações que demonstrem claramente a adequação às normas. "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("3. Tempo estimado de preenchimento: ")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " O tempo estimado para o preenchimento do formulário varia entre 20 e 45 minutos, dependendo das informações e documentos a serem inseridos. "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("4. Formato de documentos anexos: ")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " Para os itens que exigirem comprovações documentais, todos os arquivos devem ser anexados no formato PDF/A. Esse formato garante maior confiabilidade, padronização e segurança na preservação e compartilhamento das informações, além de facilitar a integridade dos dados ao longo do tempo. "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " O campo para anexar documentos só ficará visível quando a opção que exige documentação for selecionada. Por exemplo: ao marcar “Sim” em uma pergunta que solicita comprovação, o sistema abrirá automaticamente o campo para anexar o arquivo correspondente. "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _c("li", [
          _c(
            "p",
            {
              staticStyle: {
                "line-height": "130%",
                "margin-bottom": "0.49cm",
                background: "#fefefe"
              },
              attrs: { align: "justify" }
            },
            [
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [_c("b", [_vm._v("5. Confidencialidade e segurança: ")])]
              ),
              _c(
                "font",
                {
                  staticStyle: { "font-size": "13pt" },
                  attrs: { size: "3", face: "Calibri, serif" }
                },
                [
                  _vm._v(
                    " Todas as informações e documentos anexos ao Formulário de Análise de Fornecedores serão tratados sob os termos de sigilo, segurança e boa-fé previstos na relação contratual. A organização compromete-se a proteger o sigilo e a integridade de todos os dados enviados. "
                  )
                ]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " a relação jurídica contratual e de boa-fé estabelecida entre as partes, cujo objeto envolve o tratamento e processamento de dados pessoais e/ou dados pessoais sensíveis, à luz da Lei Geral de Proteção de Dados Pessoais – LGPD (Lei nº 13.709/2018); "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " que os agentes de tratamento (controlador e operador) devem adotar medidas de segurança, técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito (art. 46, LGPD); "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " que as medidas de segurança, técnicas e administrativas, devem ser adotadas desde a fase de concepção do produto ou do serviço até a sua execução (art. 46, §2º); "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " que os agentes de tratamento ou qualquer outra pessoa que intervenha em uma das fases do tratamento obrigam-se a garantir a segurança da informação e privacidade prevista na LGPD em relação aos dados pessoais, mesmo após o seu término; "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " que é obrigação do controlador comunicar à autoridade nacional de proteção de dados e ao titular a ocorrência de incidentes de segurança da informação e privacidade que possam acarretar risco ou dano relevante aos titulares (art. 48, LGPD); e "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [_c("b", [_vm._v("CONSIDERANDO ")])]
              )
            ],
            1
          ),
          _c(
            "font",
            { attrs: { face: "Calibri, serif" } },
            [
              _c(
                "font",
                { staticStyle: { "font-size": "13pt" }, attrs: { size: "3" } },
                [
                  _vm._v(
                    " as ações em curso do Programa de Adequação à Lei Geral de Proteção de Dados Pessoais, a segurança da informação e privacidade em curso em nossa organização, cujo propósito é estabelecer regras de boas práticas, levando em consideração, em relação ao tratamento e aos dados, a natureza, o escopo, a finalidade e a probabilidade e a gravidade dos riscos e dos benefícios decorrentes de tratamento de dados do titular. "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "p",
        {
          staticStyle: { "line-height": "150%", "margin-bottom": "0cm" },
          attrs: { align: "justify" }
        },
        [
          _c(
            "font",
            {
              staticStyle: { "font-size": "13pt" },
              attrs: { size: "3", face: "Calibri, serif" }
            },
            [
              _vm._v(
                " Com esta iniciativa, reforçamos nosso compromisso em garantir a proteção, a segurança e privacidade dos dados pessoais, conforme a legislação vigente. "
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }